import { Button, Flex, List, Search } from "@theorgchartdev/storybook";
import { GetDoc } from "@/Utils/StateLib";
import { getToolbarSearchQueryOptions, useChartSearch } from "@/hooks/useChartSearch";
import { appstr } from "@coreapp/utils/appstr";

type Props = { onClose: () => void };

// Full-screen phone search: recents or matches always listed beneath the field; a pick closes it.
const PhoneChartSearch = ({ onClose }: Props) => {
  const doc = GetDoc();

  const { options, loading, searchDisabled, searchHandleRef, handleInput, handleResetInput } =
    useChartSearch({
      isPositionChart: doc?.IsPositionDocument(),
      getHoldersWithNoPosition: true,
      queryOptions: getToolbarSearchQueryOptions(doc),
      onAfterResultSelect: onClose
    });

  return (
    <Flex
      direction="column"
      gap="8px"
      padding="8px 16px"
      className="ocn-phone-toolbar ocn-phone-chart-search"
    >
      <Flex alignItems="center" gap="8px" className="ocn-phone-chart-search-header">
        <Search
          placeholder={appstr("Search")}
          inputProps={{ autoComplete: "off", autoFocus: true, disabled: searchDisabled }}
          onInput={handleInput}
          onResetInput={handleResetInput}
          handleRef={searchHandleRef}
          dataTestId="phone-chart-search-input"
        />
        <Button
          modifier="tertiary"
          size="medium"
          onClick={onClose}
          dataTestId="phone-toolbar-search-cancel"
        >
          {appstr("Cancel")}
        </Button>
      </Flex>
      <List
        className="ocn-phone-chart-search-results"
        options={options}
        listWidth="fill"
        optionSize="medium"
        showLoader={loading}
        enableKeyboardCursor={false}
        data-testid="phone-chart-search-results"
      />
    </Flex>
  );
};

export default PhoneChartSearch;
